import { render, staticRenderFns } from "./burs-list-modal.vue?vue&type=template&id=b102c9da&scoped=true&"
import script from "./burs-list-modal.vue?vue&type=script&lang=js&"
export * from "./burs-list-modal.vue?vue&type=script&lang=js&"
import style0 from "./burs-list-modal.vue?vue&type=style&index=0&id=b102c9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b102c9da",
  null
  
)

export default component.exports